export const acceptedFileTypes = {
    amr: {
        icon: 'audio',
    },
    avi: {
        icon: 'video',
    },
    cdr: {
        icon: 'image',
    },
    csv: {
        icon: 'speadsheet',
    },
    doc: {
        icon: 'msword',
    },
    docx: {
        icon: 'msword',
    },
    gdoc: { icon: 'document' },
    gif: {
        icon: 'image',
    },
    gsheet: { icon: 'spreadsheet' },
    gslides: { icon: 'presentation' },
    jpeg: {
        icon: 'image',
    },
    jpg: {
        icon: 'image',
    },
    m4a: {
        icon: 'audio',
    },
    mov: { icon: 'video' },
    mp3: {
        icon: 'audio',
    },
    mp4: {
        icon: 'video',
        mimeTypes: [
            'video/mp4',
            'audio/mp4',
            'audio/x-m4a',
            'application/octetstream',
            'application/octet-stream',
        ],
    },
    odf: {
        icon: 'spreadsheet',
        mimeTypes: [
            'application/vnd.oasis.opendocument.formula',
            'application/octetstream',
            'application/octet-stream',
        ],
    },
    odp: { icon: 'presentation' },
    ods: {
        icon: 'spreadsheet',
    },
    odt: {
        icon: 'document',
    },
    otp: {
        icon: 'presentation',
    },
    ots: {
        icon: 'spreadsheet',
    },
    pot: {
        icon: 'mspowerpoint',
    },
    potx: {
        icon: 'mspowerpoint',
    },
    pdf: {
        icon: 'pdf',
    },
    png: {
        icon: 'image',
    },
    pps: {
        icon: 'mspowerpoint',
    },
    ppsx: {
        icon: 'mspowerpoint',
    },
    ppt: {
        icon: 'mspowerpoint',
    },
    pptx: {
        icon: 'mypowerpoint',
    },
    qt: { icon: 'video' },
    rar: {
        icon: 'archive',
    },
    svg: {
        icon: 'image',
    },
    tgz: {
        icon: 'archive',
    },
    tif: {
        icon: 'image',
    },
    tiff: {
        icon: 'image',
    },
    vcf: {
        icon: 'contact',
    },
    wav: {
        icon: 'audio',
    },
    wave: {
        icon: 'audio',
    },
    webp: { icon: 'image' },
    wmv: { icon: 'audio' },
    xls: {
        icon: 'msexcel',
    },
    xlsb: {
        icon: 'msexcel',
    },
    xlsm: {
        icon: 'msexcel',
    },
    xlsx: {
        icon: 'msexcel',
    },
    xltm: {
        icon: 'msexcel',
    },
    xltx: {
        icon: 'msexcel',
    },
    zip: {
        icon: 'archive',
    },
};
